"use strict";
/**
 * Force Majeure Declaration Response Types
 *
 * API response contracts for force-majeure declaration endpoints.
 *
 * @example GET /api/force-majeure
 * @example GET /api/force-majeure/:id
 */
Object.defineProperty(exports, "__esModule", { value: true });
